export enum EventActionType {
    Workflow,
    Variable,
    Documentation
}
